import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Header } from '../0_layout/HeaderFooter';
import { Footer } from '../0_layout/Footer';

const ArchiveEventsPage = () => {
  const { eventType } = useParams();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const [selectedType,] = useState('SSW');
  
  useEffect(() => {
  const fetchEvents = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + `/api/events/type-archived?type=${eventType}`
      );
      const data = await response.json();

      const sortedEvents = data.sort((a, b) => {
        const dateA = new Date(a.date.replace(/(\d{1,2})(st|nd|rd|th)/, '$1'));
        const dateB = new Date(b.date.replace(/(\d{1,2})(st|nd|rd|th)/, '$1'));
        return dateB - dateA;
      });

      setEvents(sortedEvents);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  fetchEvents();
}, [eventType]);



const eventStyles = (type) => ({
    width: { lg: '210px', sm: '90%', xs: '230px' },
    margin: 0.5,
    height: { lg: '200px', sm: '150px', xs: '150px' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 2,
    borderRadius: 2,
    textAlign: 'center',
    fontSize: '16px',
    color: 'gray',

    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'scale(1.08)',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',
    },
  });

  const eventColors = {
    SSW: '#f3e5f5',
    CSG: '#c8e6c9',
    NCOJ: '#fff9c4',
    CSAW: '#e0f7fa'
  };

  let hrstyle = {
    borderLeft: { lg: "5px solid #eb7e91" },
    borderTop: { xs: "5px solid #eb7e91" },
    height: { lg: "190px", xs: '0' },
    width: { xs: '190px', lg: '0px' },
    margin: { lg: "0 15px", xs: "15px 0" },
    borderRadius: '10px',
  }

  const eventTitles = {
    SSW: "Super Sunday Workshop",
    CSG: "CS Gems",
    NCOJ: "National Coding Olympiad Junior",
    CSAW: "C-SAW - Computer Science Teachers' Conclave",
  };

  const titleText = eventTitles[eventType] || "Other Event";




  return (
    <>
      <Header />
      <Box sx={{ pt: { xs: 12, md: 16 }, minHeight: '100vh', backgroundColor: '#fafafa' }}>
        <Box sx={{ width: '80%', mx: 'auto', p: 3 }}>
          <Typography variant="h5" sx={{ mb: 4, color: 'gray', textAlign: 'center' }}>
            Archived Events <br />
          </Typography>

          
                    <Box
                      sx={{
                        margin: 3,
                        marginBottom: { sm: 13, xs: 13, lg: 3, md: 3 },
                        display: 'flex',
                        width: '90%',
                        height: 'auto',
                        justifyContent: 'space-between',
                        flexDirection: { xs: 'column', sm: 'column', lg: 'row', md: 'row' },
                        alignItems: 'center',
          
                      }}
                    >
                      <Box
                        sx={{ ...eventStyles('SSW'), backgroundColor: '#ffebee' }}
                        onClick={() => navigate(`/archive/SSW`)}
                      >
                        Super Sunday <br /> Workshop
                      </Box>
          
                      <Box
                        sx={{ ...eventStyles('CSG'), backgroundColor: '#f3e5f5' }}
                        onClick={() => navigate(`/archive/CSG`)}
                      >
                        CS Gems
                      </Box>
                      <Box
                        sx={{ ...eventStyles('SSL'), backgroundColor: '#f3e5f5' }}
                        onClick={() => navigate(`/archive/SSL`)}
                      >
                        Super School Leadership
                      </Box>
          
                      <Box
                        sx={{ ...eventStyles('NCOJ'), backgroundColor: '#f5f5f5' }}
                        onClick={() => navigate(`/archive/NCOJ`)}
                      >
                        National Coding <br /> Olympiad Junior
                      </Box>
          
                      <Box
                        sx={{ ...eventStyles('CSAW'), backgroundColor: '#e0f7fa' }}
                        onClick={() => navigate(`/archive/CSAW`)}
                      >
                        C-SAW - Computer <br /> Science Teachers' <br /> Conclave
                      </Box>
                    </Box>
          
          

          <Typography variant="h4" sx={{ mb: 4, textAlign: 'center' }}>
            {titleText}
          </Typography>


          {events.length > 0 && (
            <Box sx={{ width: '90%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              {events.map((event, index) => (
                event && (
                  <Box
                    key={index}
                    sx={{
                      width: '100%',
                      backgroundColor: eventColors[selectedType],
                      marginBottom: 5,
                      padding: 3,
                      boxSizing: 'border-box',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexDirection: { xs: 'column', sm: 'column', lg: 'row' },
                      borderRadius: 3,
                      boxShadow: '0px 4px 20px rgba(0,0,0,0.1)'
                    }}
                  >
                    {/* Image Section */}
                    <Box sx={{ width: { lg: '30%', xs: '100%' }, marginBottom: { xs: 2, lg: 0 } }}>
                      {event.imageURL && (
                        <img
                          src={process.env.REACT_APP_API_URL + event.imageURL}
                          alt="Event"
                          style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '10px' }}
                        />
                      )}
                    </Box>

                    {/* Vertical Separator */}
                    <Box sx={hrstyle}></Box>

                    {/* Description Section */}
                    <Box sx={{
                      width: { lg: '40%', xs: '100%' },
                      padding: { xs: 1, lg: 2 },
                      textAlign: { xs: 'center', lg: 'left' },
                      fontSize: '16px'
                    }}>
                      <Box dangerouslySetInnerHTML={{ __html: event.description }}></Box>
                    </Box>

                    {/* Vertical Separator */}
                    <Box sx={hrstyle}></Box>

                    {/* Info and Button Section */}
                    <Box sx={{
                      width: { lg: '25%', xs: '100%' },
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: { xs: 2, lg: 0 }
                    }}>
                      <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Date: {event.date}</Typography>
                      <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Time: {event.time}</Typography>
                      <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Venue: {event.venue}</Typography>

                      <Button
                        onClick={() => navigate('/archieve-event-details', { state: { event } })}
                        sx={{
                          backgroundColor: '#c2185b',
                          color: 'white',
                          fontWeight: 'bold',
                          padding: '10px 20px',
                          borderRadius: '8px',
                          marginTop: 2,
                          width: '150px',
                          fontSize: '16px',
                          transition: '0.3s ease',
                          '&:hover': {
                            backgroundColor: '#eb7e91',
                            transform: 'translateY(-3px)',
                            boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)'
                          }
                        }}
                      >
                        Know More
                      </Button>
                    </Box>
                  </Box>
                )
              ))}
            </Box>
          )}

        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default ArchiveEventsPage;
